// @ts-nocheck
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';

import { SalesPeopleProvider } from './SalesPeopleProvider';
import SalespeopleDataTable from './SalesPeopleDataTable';

import withDashboardActions from '@/containers/Dashboard/withDashboardActions';

import { compose } from '@/utils';

function SalesPeopleList({
  // #withDashboardActions
  changePreferencesPageTitle,
}) {
  useEffect(() => {
    changePreferencesPageTitle(intl.get('salespeople'));
  }, [changePreferencesPageTitle]);

  return (
    <SalesPeopleProvider>
      <SalespeopleDataTable />
    </SalesPeopleProvider>
  );
}

export default compose(withDashboardActions)(SalesPeopleList);
